'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.findProductName = findProductName;
exports.buildProperties = buildProperties;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * The description message comes back in the format
 * "You can't add more {title} to the cart" so we'll split on spaces
 * and join them back on every item after the 5th
 *
 * @param str {String} The string we will be searching
 * @param alreadyInCart {Boolean} If the error is because the product is already in the cart
 *
 * @returns {String}
 */
function findProductName(str, alreadyInCart) {
  var strSplitWithoutStart = alreadyInCart ? str.split(' ').slice(2).join(' ') : str.split(' ').slice(4).join(' ');

  return strSplitWithoutStart.replace(' to the cart.', '');
}

/**
 * This builds up the line item properties for use in Javascript
 *
 * @param formData {FormData} The form we will be traversing to find the properties
 *
 * @returns {Object}
 */
function buildProperties(formData) {
  var propertyKeyValues = [].concat((0, _toConsumableArray3.default)(formData.entries())).filter(function (_ref) {
    var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    return key.includes('properties[') && value !== '';
  });

  function propertyReducer(properties, _ref3) {
    var _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
        key = _ref4[0],
        value = _ref4[1];

    var strippedKey = key.replace('properties[', '').slice(0, -1);

    return (0, _assign2.default)({}, properties, (0, _defineProperty3.default)({}, strippedKey, value));
  }

  return propertyKeyValues.reduce(propertyReducer, {});
}